<template>
    <div component="ContractDetail">
        <page-header :icon="'videocam'" :text="'Contract template'"></page-header>
        <section container="main">
            <v-snackbar class="text-center" centered v-model="showStatus" timeout="1900">
                <h3 class="success text-center" v-if="status">Template was saved.</h3>
                <h3 class="error text-center" v-else>There was error saving template.</h3>
            </v-snackbar>

            <ckeditor v-model="template" :config="editorConfig"></ckeditor>

            <v-row class="template-actions-wrapper">
                <v-col cols="6">&nbsp;</v-col>
                <v-col cols="6" class="template-actions">
                    <button @click="print" color="accent" size="icon" class="close">
                        <i class="material-icons">print</i>
                    </button>

                    <v-btn @click="template = backup_template" class="warning"> RESET </v-btn>
                    <v-btn @click="saveTemplate" class="success"> SAVE </v-btn>
                </v-col>
            </v-row>
        </section>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import TextEditor from '@/components/TextEditor/TextEditor.vue';

export default {
    name: 'ContractDetail',

    data() {
        return {
            editorConfig: {},
            backup_template: null,
            showStatus: false,
            status: false,
            showDetail: false,
        };
    },

    async mounted() {
        await this.loadContract(this.$route.params.id);
        this.backup_template = this.contract.text;
    },

    computed: {
        ...mapGetters({
            contract: 'getContractDetail',
        }),

        template: {
            get() {
                if (!this.contract) {
                    return this.backup_template;
                }
                return this.contract.text;
            },
            set(val) {
                this.setContract({
                    ...this.contract,
                    text: val,
                });
            },
        },
    },

    methods: {
        ...mapMutations({
            setContract: 'setContractDetail',
        }),

        ...mapActions({
            loadContract: 'loadContractDetail',
            storeContract: 'storeContractDetail',
        }),

        print() {
            const mywindow = window.open('', 'PRINT', 'height=400,width=600');

            mywindow.document.write('<html><head><title>' + this.contract.name + '</title>');
            mywindow.document.write('</head><body >');
            mywindow.document.write(this.template);
            mywindow.document.write('</body></html>');

            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10

            mywindow.print();
            //mywindow.close();

            return true;
        },

        async saveTemplate() {
            const status = await this.storeContract();
            this.showStatus = true;
            this.status = status;
        },
    },

    components: {
        PageHeader,
        TextEditor,
    },
};
</script>
<style lang="less" scoped>
[component='ContractDetail'] {
    padding: 0 30px 10px 30px;
    height: 100%;
    width: 100%;
    position: absolute;
    overflow: hidden;

    display: flex;
    flex-direction: column;

    [container='main'] {
        padding: 0 30px 10px 30px;
        display: flex;
        flex-direction: column;
    }

    .template-actions-wrapper {
        margin: 0;
        flex-grow: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;

        .template-actions {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
        }

        .v-btn {
            color: inherit;
            background: inherit;
        }
    }
}
</style>
<style lang="less">
@import '~@variables';

[component='ContractDetail'] {
    display: flex;
    flex-direction: column;

    [container='main'] {
        display: flex;
        flex-direction: column;
        min-height: auto !important;
        height: auto !important;
        flex: 1;

        & > div {
            display: flex;
            flex: 1;
            flex-direction: column;

            #cke_editor1 {
                flex: 1;
                display: flex;
                flex-direction: column;

                .cke_inner.cke_reset {
                    flex: 1;
                    display: flex;
                    flex-direction: column;

                    #cke_1_contents {
                        flex: 1 !important;
                    }
                }
            }
        }
    }
}
</style>
